import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { signOut } from 'firebase/auth';
import { auth } from '../../utils/firebaseClient';
import { FaSignOutAlt, FaGlobe } from 'react-icons/fa';
import { useLang } from '../../contexts/LanguageContext';

const Navbar = ({ session }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const isHomePage = location.pathname === '/';
  const { lang, toggleLang } = useLang();

  const handleLogout = async () => {
    try {
      await signOut(auth);
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error.message);
    }
  };

  const LangToggle = () => (
    <button onClick={toggleLang} className="lang-toggle" title={lang === 'en' ? 'Mudar para Português' : 'Switch to English'}>
      <FaGlobe /> {lang === 'en' ? 'PT' : 'EN'}
    </button>
  );

  if (isHomePage && !session) {
    return (
      <nav className="navbar">
        <div className="navbar-brand">TargetWise</div>
        <div className="nav-links">
          <LangToggle />
          <Link to="/login" className="nav-link">Login</Link>
        </div>
      </nav>
    );
  }

  if (session && !location.pathname.includes('/evaluate/')) {
    return (
      <nav className="navbar">
        <div className="navbar-brand">
          <Link to="/">TargetWise</Link>
        </div>
        <div className="nav-links">
          <LangToggle />
          <Link to="/create" className="nav-link">{lang === 'en' ? 'Create Dartboard' : 'Criar Dartboard'}</Link>
          <Link to="/my-events" className="nav-link">{lang === 'en' ? 'My Dartboards' : 'Os Meus Dartboards'}</Link>
          <button onClick={handleLogout} className="logout-button">
            <FaSignOutAlt /> {lang === 'en' ? 'Logout' : 'Sair'}
          </button>
        </div>
      </nav>
    );
  }

  return null;
};

export default Navbar;
